export class NICEDialerDeliverySettings {
    confirmationRequiredDisabled: boolean;
    confirmationRequiredDeliveryType: number;
    confirmationRequiredTimeout?: any;
    confirmationRequiredTimeoutSubsequent?: any;
    confirmationRequiredDefaultAccept: boolean;
    confirmationRequiredDefault: boolean;
    complianceRecordsDisabled: boolean;
    complianceRecordsDeliveryType: number;
    complianceRecordsTimeout?: any;
    complianceRecordsTimeoutSubsequent?: any;
    complianceRecordsDefaultAccept: boolean;
    showComplianceButtonReschedule: boolean;
    showComplianceButtonRequeue: boolean;
    showComplianceButtonSnooze: boolean;
    showComplianceButtonDisposition: boolean;
    showPreviewButtonReschedule: boolean;
    showPreviewButtonRequeue: boolean;
    showPreviewButtonSnooze: boolean;
    showPreviewButtonDisposition: boolean;

    constructor(jsonObject?) {
        this.confirmationRequiredDeliveryType = +jsonObject?.confirmationRequiredDeliveryType || 0;
        this.confirmationRequiredDisabled = jsonObject?.confirmationRequiredDisabled;
        this.confirmationRequiredDeliveryType = jsonObject?.confirmationRequiredDeliveryType;
        this.confirmationRequiredTimeout = jsonObject?.confirmationRequiredTimeout;
        this.confirmationRequiredTimeoutSubsequent = jsonObject?.confirmationRequiredTimeoutSubsequent;
        this.confirmationRequiredDefaultAccept = jsonObject?.confirmationRequiredDefaultAccept;
        this.confirmationRequiredDefault = jsonObject?.confirmationRequiredDefault;
        this.complianceRecordsDisabled = jsonObject?.complianceRecordsDisabled;
        this.complianceRecordsDeliveryType = jsonObject?.complianceRecordsDeliveryType;
        this.complianceRecordsTimeout = jsonObject?.complianceRecordsTimeout;
        this.complianceRecordsTimeoutSubsequent = jsonObject?.complianceRecordsTimeoutSubsequent;
        this.complianceRecordsDefaultAccept = jsonObject?.complianceRecordsDefaultAccept;
        this.showComplianceButtonReschedule = jsonObject?.showComplianceButtonReschedule;
        this.showComplianceButtonRequeue = jsonObject?.showComplianceButtonRequeue;
        this.showComplianceButtonSnooze = jsonObject?.showComplianceButtonSnooze;
        this.showComplianceButtonDisposition = jsonObject?.showComplianceButtonDisposition;
        this.showPreviewButtonReschedule = jsonObject?.showPreviewButtonReschedule;
        this.showPreviewButtonRequeue = jsonObject?.showPreviewButtonRequeue;
        this.showPreviewButtonSnooze = jsonObject?.showPreviewButtonSnooze;
        this.showPreviewButtonDisposition = jsonObject?.showPreviewButtonDisposition;
    }
}
